import { gql } from '@apollo/client';
import SearchResultsFooterWithFragment from '../footer/search-results-footer-with-fragment';
import { ContactSearchProfileCardWithFragment } from '../contact-profile-card';
import { AgencySearchProfileCardWithFragment } from '../agency-profile-card';

export const SEARCH_QUERY = gql`
  query AgencySearch(
    $suburbSlugs: [String!]!
    $agencySortBy: AgencySearchSortBy
    $contactSortBy: ContactSearchSortBy
    $page: Int
    $pageSize: Int
    $agentFilter: AgentSearchContactTypes
    $keywordName: String
    $includeAgents: Boolean
    $isAgencyView: Boolean!
  ) {
    contactSearchBySuburbs(
      suburbSlugs: $suburbSlugs
      sortBy: $contactSortBy
      page: $page
      pageSize: $pageSize
      agentType: $agentFilter
      agentNameKeyword: $keywordName
    ) {
      total
      totalPages
      pageNumber
      results @skip(if: $isAgencyView) {
        id
        ...ContactSearchProfileCard
      }
    }
    agencySearchBySuburbs(
      suburbSlugs: $suburbSlugs
      sortBy: $agencySortBy
      page: $page
      pageSize: $pageSize
      agencyNameKeyword: $keywordName
      includeAgents: $includeAgents
    ) {
      total
      totalPages
      pageNumber
      results @include(if: $isAgencyView) {
        id
        ...AgencySearchProfileCard
      }
    }
    locationProfiles(urlSlugs: $suburbSlugs) {
      id
      suburbName
      state
      postcode
      urlSlug
      ...SearchResultsFooter @include(if: $isAgencyView)
    }
  }
  ${ContactSearchProfileCardWithFragment.fragment}
  ${AgencySearchProfileCardWithFragment.fragment}
  ${SearchResultsFooterWithFragment.fragment}
`;

export { PAGE_SIZE } from './page-size';
